import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { goldICon, vipRanked } from 'components/ui-kit/Icons/png/index'
import {
  setShowProfileChangePopup,
  setShowTipPopup,
  setShowUserDetailsPopup
} from 'redux-thunk/redux/slices/settings.slice'
import Loader from 'components/ui-kit/Loader/index'
import { LOADER_HANDLER_TYPES } from 'constants/index'
import CommonPopup from 'components/ui-kit/CommonPopup/index'
import { EmptyIcon } from 'components/ui-kit/Icons/svg/index'
import SocialMedia from './components/SocialMedia/index'
import Badges from './components/Badges/index'
import Statistics from './components/Statistics/index'

const UserDetailsPopup = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { loginData } = useSelector((state) => state.auth)
  const { userData } = useSelector((state) => state.chat)
  const { [LOADER_HANDLER_TYPES.userDetails]: loading } = useSelector(
    (state) => state.loader
  )
  const { user } = useSelector((state) => state.user)

  const modalCloseHandler = () => {
    dispatch(setShowUserDetailsPopup(false))
  }

  const handleTipping = useCallback(() => {
    dispatch(setShowTipPopup(true))
    const element = document.querySelector('.user-profile-modal')
    element?.classList?.add('remove-blur')
  })

  return (
    <CommonPopup
      modalCloseHandler={modalCloseHandler}
      classes='chat-modal user-profile-modal text-white'
      modalDialogClass='max-w-[442px] max-md:m-0 max-md:max-w-full'
      id='login_modal'
    >
      {loading
        ? (
          <Loader
            variant={LOADER_HANDLER_TYPES.content}
            style={{ minHeight: '300px' }}
          />
          )
        : (
          <>
            <div className='chat-modal-header-wrap'>
              <div className='chat-modal-profile-header'>
                <div className='chat-modal-profile-img d-flex align-items-center justify-content-center'>
                  {userData?.profileImageUrl
                    ? <img src={userData?.profileImageUrl} alt='Profile Img' />
                    : <EmptyIcon height={80} width={80} />}
                </div>
                <div className='chat-modal-header-details d-flex align-items-center'>
                  <div className='chat-modal-header-left mx-2'>
                    <img src={userData?.userRankDetails?.imageLogo || vipRanked} height={62} width={62} alt='Vip ranked' />
                  </div>
                  <div className='chat-modal-header-right'>
                    <div className='d-flex align-items-center mb-1'>
                      <h4 className='m-0'>{userData?.name}</h4>
                      {userData?.name !== user?.userName &&
                    loginData?.accessToken && (
                      <button
                        type='button'
                        className='btn tip-btn'
                        onClick={handleTipping}
                      >
                        <img src={goldICon} alt='Coin' className='me-2' />
                        <span className='text'>{t('tip')}</span>
                      </button>
                      )}
                      {userData?.id.toString() === user?.id?.toString() &&
                        <button
                          type='button'
                          className='btn edit-btn'
                          onClick={() => {
                            dispatch(setShowProfileChangePopup(true))
                            const element = document.querySelector('.user-profile-modal')
                            element?.classList?.add('remove-blur')
                          }}
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 24 24'
                            fill='currentColor'
                            className='w-4 h-4 cursor-pointer'
                            aria-hidden='true'
                          >
                            <path d='M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' />
                          </svg>
                        </button>}
                    </div>
                    <div className='progrees-content align-items-center justify-content-between'>
                      <p className='m-0'>
                        {t('rank')} :
                        <span
                          className='text-uppercase'
                          style={{ color: userData?.userRankDetails?.moreDetails?.color }}
                        >{userData?.userRankDetails?.rank}
                        </span>
                      </p>
                    </div>
                    <div className='progress'>
                      <div
                        className='progress-bar'
                        role='progressbar'
                        aria-valuenow={userData?.userWagerAmount || 0}
                        aria-valuemin='0'
                        aria-valuemax={userData?.nextRankingDetails?.[0]?.wagerRequirement}
                        style={{
                          width: `${(((+userData?.userWagerAmount) / (+userData?.nextRankingDetails?.[0]?.wagerRequirement)) * 100)}%`,
                          backgroundColor: userData?.userRankDetails?.moreDetails?.color
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <SocialMedia />
            <Badges />
            {!userData?.isPrivate && <Statistics />}
          </>
          )}
    </CommonPopup>
  )
}

export default UserDetailsPopup
